export default function GoalIcon({
  type = 'regular',
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  type?: 'bold' | 'regular';
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      {type === 'regular' && (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 32 32'
          fill='currentColor'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.44446 6.8086C3.44446 5.15174 4.7876 3.80859 6.44446 3.80859H12.2222C13.8791 3.80859 15.2222 5.15174 15.2222 6.80859V12.5864C15.2222 14.2432 13.8791 15.5864 12.2222 15.5864H6.44446C4.78761 15.5864 3.44446 14.2432 3.44446 12.5864V6.8086ZM6.44446 5.80859C5.89217 5.80859 5.44446 6.25631 5.44446 6.8086V12.5864C5.44446 13.1387 5.89217 13.5864 6.44446 13.5864H12.2222C12.7745 13.5864 13.2222 13.1387 13.2222 12.5864V6.80859C13.2222 6.25631 12.7745 5.80859 12.2222 5.80859H6.44446Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M28.5555 25.9199C28.5555 27.5768 27.2124 28.9199 25.5555 28.9199L19.7778 28.9199C18.1209 28.9199 16.7778 27.5768 16.7778 25.9199L16.7778 20.1421C16.7778 18.4853 18.1209 17.1421 19.7778 17.1421L25.5555 17.1421C27.2124 17.1421 28.5555 18.4853 28.5555 20.1421L28.5555 25.9199ZM25.5555 26.9199C26.1078 26.9199 26.5555 26.4722 26.5555 25.9199L26.5555 20.1421C26.5555 19.5899 26.1078 19.1421 25.5555 19.1421L19.7778 19.1421C19.2255 19.1421 18.7778 19.5899 18.7778 20.1421L18.7778 25.9199C18.7778 26.4722 19.2255 26.9199 19.7778 26.9199L25.5555 26.9199Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.33335 19.1426C7.18557 19.1426 5.44446 20.8837 5.44446 23.0315C5.44446 25.1792 7.18557 26.9204 9.33335 26.9204C11.4811 26.9204 13.2222 25.1792 13.2222 23.0315C13.2222 20.8837 11.4811 19.1426 9.33335 19.1426ZM3.44446 23.0315C3.44446 19.7791 6.081 17.1426 9.33335 17.1426C12.5857 17.1426 15.2222 19.7791 15.2222 23.0315C15.2222 26.2838 12.5857 28.9204 9.33335 28.9204C6.081 28.9204 3.44446 26.2838 3.44446 23.0315Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M22.6667 13.5859C24.8144 13.5859 26.5555 11.8448 26.5555 9.69705C26.5555 7.54928 24.8144 5.80816 22.6667 5.80816C20.5189 5.80816 18.7778 7.54927 18.7778 9.69705C18.7778 11.8448 20.5189 13.5859 22.6667 13.5859ZM28.5555 9.69705C28.5555 12.9494 25.919 15.5859 22.6667 15.5859C19.4143 15.5859 16.7778 12.9494 16.7778 9.69705C16.7778 6.4447 19.4143 3.80816 22.6667 3.80816C25.919 3.80816 28.5555 6.44471 28.5555 9.69705Z'
          />
        </svg>
      )}
      {type === 'bold' && (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 20 20'
          fill='currentColor'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.50016 2.50016H2.50016L2.50016 7.50016H7.50016V2.50016ZM2.50016 0.833496C1.57969 0.833496 0.833496 1.57969 0.833496 2.50016V7.50016C0.833496 8.42064 1.57969 9.16683 2.50016 9.16683H7.50016C8.42064 9.16683 9.16683 8.42064 9.16683 7.50016V2.50016C9.16683 1.57969 8.42064 0.833496 7.50016 0.833496H2.50016Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.5002 12.5002H12.5002L12.5002 17.5002H17.5002V12.5002ZM12.5002 10.8335C11.5797 10.8335 10.8335 11.5797 10.8335 12.5002V17.5002C10.8335 18.4206 11.5797 19.1668 12.5002 19.1668H17.5002C18.4206 19.1668 19.1668 18.4206 19.1668 17.5002V12.5002C19.1668 11.5797 18.4206 10.8335 17.5002 10.8335H12.5002Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.0002 7.50016C16.3809 7.50016 17.5002 6.38087 17.5002 5.00016C17.5002 3.61945 16.3809 2.50016 15.0002 2.50016C13.6195 2.50016 12.5002 3.61945 12.5002 5.00016C12.5002 6.38087 13.6195 7.50016 15.0002 7.50016ZM15.0002 9.16683C17.3013 9.16683 19.1668 7.30135 19.1668 5.00016C19.1668 2.69898 17.3013 0.833496 15.0002 0.833496C12.699 0.833496 10.8335 2.69898 10.8335 5.00016C10.8335 7.30135 12.699 9.16683 15.0002 9.16683Z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.00016 17.5002C6.38087 17.5002 7.50016 16.3809 7.50016 15.0002C7.50016 13.6195 6.38087 12.5002 5.00016 12.5002C3.61945 12.5002 2.50016 13.6195 2.50016 15.0002C2.50016 16.3809 3.61945 17.5002 5.00016 17.5002ZM5.00016 19.1668C7.30135 19.1668 9.16683 17.3013 9.16683 15.0002C9.16683 12.699 7.30135 10.8335 5.00016 10.8335C2.69898 10.8335 0.833496 12.699 0.833496 15.0002C0.833496 17.3013 2.69898 19.1668 5.00016 19.1668Z'
          />
        </svg>
      )}
    </span>
  );
}
